<template>
  <div>
    <pageTable
      :parentPage="pagination"
      @getItems="getDevices"
      :hasAdd="isEngineer"
      :hasEdit="!isAssistant"
      :hasRemove="isAdmin"
      @addItem="addDevice"
      @editItem="editDevice"
      @removeItem="removeDevice"
      @trdbClicked="editDevice"
      :items="devices"
      :columns="columns"
      :idProperty="idProperty"
      :nameProperty="nameProperty"
      :hasPage="true"
      :isSortable="true"
    >
      <template v-if="!isAssistant" slot="button" slot-scope="props">
        <button
          v-if="isEngineer"
          type="button"
          class="btn btn-outline-warning btn-icon"
          @click="openChangeDevice(props.index)"
        >
          <i class="fas fa-key"></i>
        </button>
      </template>
    </pageTable>

    <modalPart
      :isShow="isShowModal"
      @onClosed="isShowModal = !isShowModal"
      @onSaved="saveDevice"
      :title="modalTitle"
      modalId="device"
      modalClass="modal-lg"
    >
      <div slot="item">
        <div class="row">
          <div v-if="!isAdd" class="col-md-6">
            <div class="form-group">
              <label for="DeviceId">編號</label>
              <input
                type="text"
                class="form-control"
                id="DeviceId"
                v-model="device.DeviceId"
                :disabled="!isAdd"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="deviceName">網站名稱</label>
              <input
                type="text"
                class="form-control"
                id="deviceName"
                v-model="device.DeviceName"
                required
              />
            </div>
          </div>
          <div v-if="!isAdd" class="col-md-6">
            <div class="form-group">
              <label for="CpuId">CPU金鑰</label>
              <input
                type="text"
                class="form-control"
                id="CpuId"
                v-model="device.CpuId"
                :disabled="!isAdd"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="KDSServeIP">伺服器網址(完整)</label>
              <input
                type="text"
                class="form-control"
                id="KDSServerIP"
                v-model="device.KDSServerIP"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="statusType">狀態</label>
              <select
                class="form-control"
                id="statusType"
                v-model="device.StatusType"
              >
                <option
                  v-for="statusType in statusTypes"
                  :key="statusType.value"
                  :value="statusType.value"
                >
                  {{ statusType.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6"></div>
          <div class="col-12">
            <div class="form-group">
              <label for="deviceMemo">備註</label>
              <input
                type="text"
                class="form-control"
                id="deviceMemo"
                v-model="device.Memo"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="startDate">開始日期</label>
              <input
                type="date"
                class="form-control"
                id="startDate"
                v-model="device.StartDate"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="endDate">結束日期</label>
              <input
                type="date"
                class="form-control"
                id="endDate"
                v-model="device.EndDate"
              />
            </div>
          </div>
        </div>
      </div>
    </modalPart>

    <modalPart
      :isShow="isShowChangeDevice"
      @onClosed="isShowChangeDevice = false"
      @onSaved="changeDevice"
      :title="modalTitle"
      modalId="changeDevice"
      modalClass="modal-lg"
    >
      <div slot="item">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="changeCpuId">CPU ID</label>
              <input
                type="text"
                class="form-control"
                id="changeCpuId"
                v-model="cpuId"
                required
              />
            </div>
          </div>
        </div>
      </div>
    </modalPart>
  </div>
</template>

<script>
import pageTable from "@/components/PageTable";
import itemModal from "@/components/ItemModal";
import modalPart from "@/components/parts/modalPart";

export default {
  data() {
    return {
      searchDTO: {},
      business: {},
      devices: [],
      device: {},
      pagination: {},
      isShowModal: false,
      isShowChangeDevice: false,
      modalTitle: "",
      columns: [
        {
          name: "CreateTime",
        },
        {
          name: "DeviceId",
          headerText: "KDSServer編號",
        },
        {
          name: "DeviceName",
          headerText: "KDSServer名稱",
        },
        {
          name: "CpuId",
          headerText: "CPU金鑰",
        },
        {
          name: "KDSServerIP",
        },
        {
          name: "StartDate",
        },
        {
          name: "EndDate",
        },
        {
          name: "KeyId",
        },
        {
          name: "StatusType",
        },
        {
          name: "Memo",
          width: 200,
        },
      ],
      statusTypes: [
        {
          value: 0,
          text: "停用",
        },
        {
          value: 1,
          text: "啟用",
        },
      ],
      idProperty: "DeviceId",
      nameProperty: "DeviceName",
      isAdd: false,
      currentDeviceId: "",
      cpuId: "",
    };
  },
  components: {
    pageTable,
    itemModal,
    modalPart,
  },
  computed: {
    isEngineer() {
      return this.$enum.roleType.isEngineer();
    },
    isAssistant() {
      return this.$enum.roleType.isAssistant();
    },
    isAdmin() {
      return this.$enum.roleType.isAdmin();
    },
  },
  methods: {
    openChangeDevice(index) {
      if (index < 0) {
        this.$func.message.alert("請選擇一筆資料 !");
        return;
      }
      this.cpuId = "";
      this.currentDeviceId = this.devices[index].DeviceId;
      this.isShowChangeDevice = true;
      this.modalTitle = "更換金鑰";
    },
    changeDevice() {
      const vm = this;
      this.$api.devices
        .changeDevice(this.currentDeviceId, {
          CpuId: this.cpuId,
          ProductType: 6,
        })
        .then(() => {
          vm.$func.message.success("金鑰更換成功 !");
          vm.isShowChangeDevice = false;
          vm.getDevices();
        })
        .catch((error) => {
          vm.$func.message.error(error.data.Message);
        });
    },
    setOptions() {
      this.productTypes = this.$enum.productType.getAll();
      if (this.device.IsDining) {
        this.tableOrderTypes = this.$enum.tableOrderType.getAll();
      } else {
        this.tableOrderTypes =
          this.$enum.tableOrderType.getAllByCheckoutFirst();
      }
      this.productTypes.splice(0, 0, {
        value: -1,
        name: "All",
        text: "全部",
      });
    },
    getDevices(dTO) {
      if (!this.business || !this.business.BusinessId) return;
      const vm = this;
      this.searchDTO.ProductType = 6;
      this.$api.devices
        .gets(vm.business.BusinessId, { ...dTO, ...this.searchDTO })
        .then((data) => {
          vm.devices = data.Datas;
          vm.pagination = data.Pagination;
        });
    },
    addDevice() {
      this.device = {
        DeviceName: "KDS Web",
      };
      this.device.ProductType = 6;
      this.isAdd = true;
      this.isShowModal = !this.isShowModal;
      this.modalTitle = "新增KDS";
    },
    editDevice(item) {
      this.isAdd = false;
      const vm = this;
      this.$api.devices.get(item.DeviceId).then((data) => {
        vm.device = data;
        vm.isShowModal = !vm.isShowModal;
        vm.modalTitle = "修改KDS";
      });
    },
    removeDevice(item) {
      this.$api.devices.removeKDSServer(item.DeviceId).then(() => {
        this.getDevices();
      });
    },
    saveDevice() {
      this.device.BusinessId = this.business.BusinessId;
      const vm = this;
      if (this.isAdd) {
        this.$api.devices
          .save(vm.device)
          .then(() => {
            vm.isShowModal = !vm.isShowModal;
            vm.getDevices();
          })
          .catch((error) => vm.$func.message.error(error.data.Message));
      } else {
        this.$api.devices
          .put(vm.device)
          .then(() => {
            vm.isShowModal = !vm.isShowModal;
            vm.getDevices();
          })
          .catch((error) => vm.$func.message.error(error.data.Message));
      }
    },
  },
  mounted() {
    this.setOptions();
    const vm = this;
    this.$api.businesses.get(vm.$route.params["id"]).then((data) => {
      if (!data) vm.$route.go(-1);
      vm.business = data;
      vm.getDevices();
    });
  },
};
</script>
